import { createMuiTheme } from '@material-ui/core/styles';

const CKP_COLOR_BLACK = '#000000';
const CKP_COLOR_WHITE = '#ffffff';
const CKP_COLOR_RED = '#bd513b';
const CKP_COLOR_BLUE = '#5c84a8';

export const THEME_WHITE = 'THEME_WHITE';
export const THEME_BLACK = 'THEME_BLACK';

export const THEME_COLORS = {
    [THEME_BLACK]: CKP_COLOR_BLACK,
    [THEME_WHITE]: CKP_COLOR_WHITE
};

export const THEME_COLORS_SECONDARY = {
    [THEME_BLACK]: CKP_COLOR_BLUE,
    [THEME_WHITE]: CKP_COLOR_WHITE
};

export const themeClass = (themeName = THEME_BLACK) =>
    ({
        [THEME_BLACK]: 'is-black',
        [THEME_WHITE]: 'is-white'
    }[themeName]);

export const theme = (themeName = THEME_BLACK) =>
    createMuiTheme({
        overrides: {
            MuiInput: {
                underline: {
                    '&:before': {
                        'border-bottom': `1px solid ${THEME_COLORS[themeName]}`
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        'border-bottom': `2px solid ${THEME_COLORS[themeName]}`
                    }
                }
            },
            MuiMenuItem: {
                root: {
                    '&$selected': {
                        backgroundColor: CKP_COLOR_WHITE,
                        color: CKP_COLOR_BLUE
                    }
                }
            },
            MuiPickersToolbar: {
                toolbar: {
                    backgroundColor: CKP_COLOR_BLACK
                }
            },
            MuiPickerDTTabs: {
                tabs: {
                    backgroundColor: CKP_COLOR_WHITE,
                    color: CKP_COLOR_BLACK
                }
            },
            MuiPickersDay: {
                selected: {
                    backgroundColor: CKP_COLOR_BLACK,
                    color: CKP_COLOR_WHITE
                },
                current: {
                    color: CKP_COLOR_BLUE
                }
            }
        },
        palette: {
            primary: {
                light: THEME_COLORS[themeName],
                main: THEME_COLORS[themeName],
                dark: THEME_COLORS[themeName],
                contrastText: THEME_COLORS[themeName]
            },
            secondary: {
                light: THEME_COLORS_SECONDARY[themeName],
                main: THEME_COLORS_SECONDARY[themeName],
                dark: THEME_COLORS_SECONDARY[themeName],
                contrastText: THEME_COLORS_SECONDARY[THEME_WHITE]
            },
            error: {
                light: CKP_COLOR_RED,
                main: CKP_COLOR_RED,
                dark: CKP_COLOR_RED,
                contrastText: CKP_COLOR_RED
            },
            text: {
                disabled: THEME_COLORS[themeName],
                secondary: THEME_COLORS[themeName]
            }
        },
        typography: {
            fontFamily: 'Heebo, sans-serif'
        }
    });



// WEBPACK FOOTER //
// ./src/constants/styling/themes.js